import * as DOM from './utils';

export default function baseLayerControl(leaflet) {
    const { baseLayers, overlayLayers } = this.config;
    const { layerGroup, tileLayer } = leaflet;

    const tilepane = document.querySelector('.leaflet-pane .leaflet-tile-pane');

    const el = {
        control: DOM.createElement('div', { id: 'baseLayerControl' }),
        baseLayerContainer: DOM.createElement('div', { class: 'baseLayerContainer' }),
        baseLayerList: DOM.createElement('ul', { class: 'baseLayerList' }),
        divider: DOM.createElement('div', { class: 'divider' }),
        overlayLayerContainer: DOM.createElement('div', { class: 'overlayLayerContainer' }),
        overlayLayerList: DOM.createElement('ul', { class: 'overlayLayerList' }),
    };

    el.baseLayerContainer.appendChild(el.baseLayerList);
    el.overlayLayerContainer.appendChild(el.overlayLayerList);
    el.control.appendChild(el.baseLayerContainer);
    el.control.appendChild(el.divider);
    el.control.appendChild(el.overlayLayerContainer);

    this.state.baseLayersGroup = layerGroup().addTo(this.map);
    this.state.overlayLayersGroup = layerGroup().addTo(this.map);

    el.control.addEventListener('click', (e) => {
        if (e.target && e.target.nodeName === 'LI') {
            const item = e.target;
            const selected = DOM.hasClass(item, 'selected');
            const type = item.getAttribute('type');
            const rowID = item.getAttribute('rowID');
            const greyscale = item.getAttribute('greyscale');
            const background = item.getAttribute('background');

            if (type === 'baseLayer') {
                if (selected) { return; }
                if (greyscale === 'true') { tilepane.classList.add('grayscale'); } else { tilepane.classList.remove('grayscale'); }
                DOM.clearClassQ(el.baseLayerList, 'selected');
                item.classList.add('selected');
                item.firstChild.classList.add('selected');
                this.state.baseLayersGroup.clearLayers();
                this.state.baseLayersGroup.addLayer(this.state.baseLayers[rowID]);
            } else if (selected) {
                item.classList.remove('selected');
                item.firstChild.classList.remove('selected');
                this.state.overlayLayersGroup.removeLayer(this.state.overlayLayers[rowID]);
            } else {
                DOM.clearClass(el.overlayLayerList, 'selected');
                item.classList.add('selected');
                item.firstChild.classList.add('selected');
                this.state.overlayLayersGroup.addLayer(this.state.overlayLayers[rowID]);
            }
            if (background) { this._elements.map.style.background = background; }
        }
    });

    let baseLayerAdded = false;
    for (let i = 0; i < baseLayers.length; i += 1) {
        const baseLayer = baseLayers[i];
        const item = DOM.createElement('li', {
            class: 'layer', rowID: i, type: 'baseLayer', greyscale: baseLayer.greyscale, background: baseLayer.background,
        });
        const radio = DOM.createElement('div', { class: 'radio' });
        const text = DOM.createElement('span');
        text.innerText = baseLayer.name;

        let layer;
        if (baseLayer.wms) {
            layer = tileLayer.wms((baseLayer.url), baseLayer.options);
        } else {
            layer = tileLayer((baseLayer.url), baseLayer.options);
        }

        if (!baseLayerAdded && baseLayer.default) {
            baseLayerAdded = true;
            this.state.baseLayersGroup.addLayer(layer);
            item.classList.add('selected');
            radio.classList.add('selected');
            if (baseLayer.greyscale === true) { tilepane.classList.add('grayscale'); }
        }

        this.state.baseLayers.push(layer);

        item.appendChild(radio);
        item.appendChild(text);

        el.baseLayerList.appendChild(item);
    }

    for (let j = 0; j < overlayLayers.length; j += 1) {
        const overlayLayer = overlayLayers[j];
        const item = DOM.createElement('li', { class: 'layer', rowID: j, type: 'ovelayLayer' });
        const checkbox = DOM.createElement('div', { class: 'checkbox' });
        const text = DOM.createElement('span');
        text.innerText = overlayLayer.name;

        let layer;
        if (overlayLayer.wms) {
            layer = tileLayer.wms((overlayLayer.url), overlayLayer.options);
        } else {
            layer = tileLayer((overlayLayer.url), overlayLayer.options);
        }

        if (overlayLayer.default) {
            this.state.overlayLayersGroup.addLayer(layer);
            item.classList.add('selected');
            checkbox.classList.add('selected');
        }

        this.state.overlayLayers.push(layer);

        item.appendChild(checkbox);
        item.appendChild(text);

        el.overlayLayerList.appendChild(item);
    }

    if (overlayLayers.length === 0) { el.divider.style.display = 'none'; }
    this._elements.baseLayerControl = el.control;
    this._elements.interface.appendChild(el.control);

    // mobile button
    const mobEl = {
        container: DOM.createElement('div', { id: 'baseLayerControl-mobile' }),
    };

    mobEl.container.addEventListener('click', () => {
        if (this._elements.baseLayerControl.style.display === '' || this._elements.baseLayerControl.style.display === 'none') {
            this._elements.baseLayerControl.style.display = 'block';
            if (this._elements.displayLayerControl.style.display === 'block') {
                this._elements.displayLayerControl.style.display = 'none';
            }
        } else {
            this._elements.baseLayerControl.style.display = 'none';
        }
    });
    this._elements.interface.appendChild(mobEl.container);
}
